import { useCallback, useEffect } from "react"

function useShowConfirmationTextOnPopState({
  onCleanup,
  errorMessage,
  predicate,
}) {
  const onPopState = useCallback(() => {
    setTimeout(() => {
      if (predicate) {
        const leave = confirm(errorMessage())
        if (leave) {
          window.removeEventListener("popstate", onPopState)
          history.back()
          onCleanup()
        } else {
          history.pushState(null, null, null)
        }
      } else {
        history.back()
        onCleanup()
      }
    }, 0)
  }, [predicate])

  useEffect(() => {
    history.pushState(null, null, null)

    return () => {
      onCleanup()
    }
  }, [])

  useEffect(() => {
    window.addEventListener("popstate", onPopState)
    return () => {
      window.removeEventListener("popstate", onPopState)
    }
  }, [onPopState])

  return onPopState
}

export default useShowConfirmationTextOnPopState
